import BillableService from '../../services/BillableService';
import HorseService from '../../services/HorseService';
import BarnService from '../../services/BarnService';

import * as types from './types';
import {
  dispatchNetworkRequest,
  dispatchNetworkRequestDynamicSuccessDispatch,
} from '../networkDispatcher';

export const getBillables = (horseIds, barnUserIds, locationId, taskTypeId, note, status, startDate, endDate, page = 0, pageSize = 25, sort = '') => (dispatch) => {
  const promise = BillableService.getBillables(horseIds, barnUserIds, locationId, taskTypeId, note, status, startDate, endDate, page, pageSize, sort);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_BILLABLES_REQUESTED,
    successType: types.GET_BILLABLES_SUCCESS,
    errorType: types.GET_BILLABLES_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading billables for this organization',
    responseName: 'billables',
  });
  return promise;
};

export const getRepeatingBillables = (horseIds, barnUserIds, locationId, taskTypeId, page = 0, pageSize = 25, sort = '') => (dispatch) => {
  const promise = BillableService.getRepeatingBillables(horseIds, barnUserIds, locationId, taskTypeId, page, pageSize, sort);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_REPEATING_BILLABLES_REQUESTED,
    successType: types.GET_REPEATING_BILLABLES_SUCCESS,
    errorType: types.GET_REPEATING_BILLABLES_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading repeating billables for this organization',
    responseName: 'billables',
  });
  return promise;
};

export const addBillable = (horseId, request) => (dispatch) => {
  const promise = HorseService.addHorseBillable(horseId, request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.ADD_BILLABLES_REQUESTED,
    successType: types.ADD_BILLABLES_SUCCESS,
    errorType: types.ADD_BILLABLES_ERROR,
    promise,
    successMessage: 'Successfully created the billable',
    defaultErrorMessage: 'There was a problem adding the billable to the horse',
    responseName: 'newBillable',
  });
  return promise;
};

export const getBillablesAnalytics = (horseIds, locationId, taskTypeId, groupBy, startDate, endDate) => (dispatch) => {
  const promise = BillableService.getBillablesAnalytics(horseIds, locationId, taskTypeId, groupBy, startDate, endDate);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_BARN_BILLABLES_ANALYTICS_REQUESTED,
    successType: types.GET_BARN_BILLABLES_ANALYTICS_SUCCESS,
    errorType: types.GET_BARN_BILLABLES_ANALYTICS_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading billables analytics for this organization',
    responseName: 'analytics',
  });
  return promise;
};

export const updateBillable = (id, request) => (dispatch) => {
  const promise = BillableService.updateBillable(id, request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.UPDATE_BILLABLES_REQUESTED,
    successType: types.UPDATE_BILLABLES_SUCCESS,
    errorType: types.UPDATE_BILLABLES_ERROR,
    promise,
    successMessage: 'Successfully updated the billable',
    defaultErrorMessage: 'There was a problem updating the billable',
    responseName: 'updatedBillable',
  });
  return promise;
};

export const deleteBillable = (id) => (dispatch) => {
  const promise = BillableService.deleteBillable(id);
  dispatchNetworkRequestDynamicSuccessDispatch({
    dispatch,
    requestType: types.DELETE_BILLABLES_REQUESTED,
    successDispatch: {
      type: types.DELETE_BILLABLES_SUCCESS,
      deletedBillableId: id,
    },
    errorType: types.DELETE_BILLABLES_ERROR,
    promise,
    successMessage: 'Successfully deleted the billable',
    defaultErrorMessage: 'There was a problem deleting the billable',
    responseName: 'response',
  });
  return promise;
};

export const getBarnBillablesRollup = (id) => (dispatch) => {
  const promise = BarnService.getHorseBillablesRollup(id);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_BARN_BILLABLES_ROLLUP_REQUESTED,
    successType: types.GET_BARN_BILLABLES_ROLLUP_SUCCESS,
    errorType: types.GET_BARN_BILLABLES_ROLLUP_ERROR,
    promise,
    successMessage: 'Successfully retrieved barn billable rollup',
    defaultErrorMessage: 'There was a problem getting barn billable rollup',
    responseName: 'rollup',
  });
  return promise;
};

export const getInvoicesForBillable = (id) => (dispatch) => {
  const promise = BillableService.getInvoicesForBillable(id);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_BILLABLE_INVOICES_REQUESTED,
    successType: types.GET_BILLABLE_INVOICES_SUCCESS,
    errorType: types.GET_BILLABLE_INVOICES_ERROR,
    promise,
    successMessage: 'Successfully retrieved invoices for billable',
    defaultErrorMessage: 'There was a problem getting the invoices with this billable',
    responseName: 'billableInvoices',
  });
  return promise;
};
